/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockRecipeManageShareCtrl
 */
angular.module('mercury.modules.stock.recipe')
.controller('StockRecipeManageShareCtrl', ["dialog", "$filter", "$q", "recipeId", "$rootScope", "$scope", "StockSharedRecipes", "userinfo", function(dialog, $filter, $q, recipeId, $rootScope, $scope, StockSharedRecipes, userinfo) {
  $scope.recipes = StockSharedRecipes.get(recipeId);

  $scope.activeCompanies = userinfo.avaliableCompanies();

  var updateUnsharedCompanies = function() {
    $scope.unsharedCompanies = [];
    angular.forEach($scope.activeCompanies, function(company) {
      if ($filter('filter')($scope.recipes, {sharedCompanyId: company.id}).length === 0) {
        $scope.unsharedCompanies.push({id: company.id, name: company.name});
      }
    });
  };

  $scope.recipes.$promise.then(function() {
    // Order the items so the current company is on top, then alphabetical.
    $scope.recipes = $filter('orderBy')($scope.recipes, [
      function(recipe) {
        return recipe.sharedCompanyId == userinfo.activeCompany() ? 0 : 1;
      },
      'sharedCompanyShortName'
    ]);

    updateUnsharedCompanies();
  });

  $scope.linkItem = function(companyId) {
    $scope.$close();
    dialog.open({
      templateUrl: 'modules/stock/recipe/share.tpl.html',
      controller: 'StockRecipeShareCtrl',
      resolve: {
        recipeIds: function() {
          return [recipeId];
        },
        companyId: function() {
          return companyId;
        }
      }
    });
  };

  $scope.deleteSharedRecipe = function(index) {
    var sharedRecipe = $scope.recipes[index];

    StockSharedRecipes.deleteCompanyRecipe(sharedRecipe)
    .then(function() {
      if (sharedRecipe.sharedCompanyId == userinfo.activeCompany()) {
        $rootScope.$broadcast('manageSharedRecipeUpdated', {
          id: recipeId,
          isShared: false,
          datestampDeleted: moment().format()
        });
        $scope.$close();
      } else {
        $scope.recipes.splice(index, 1);

        // There is only 1 shared item left, so it is no longer shared.
        if ($scope.recipes.length == 1) {
          $rootScope.$broadcast('manageSharedRecipeUpdated', {
            id: recipeId,
            isShared: false
          });
          $scope.$close();
        }
      }

      updateUnsharedCompanies();
    });
  };
}]);
